<div class="button-option-container">
    <div class="option">
        <div>
            {{ 'mimic.settings.button-intercation.flashing' | translate }}
        </div>
        <div class="flashing-option-toggle">
            <div>
                <ng-container *ngIf="!flashingOptionIsOpen">
                    {{ 'mimic.settings.button-intercation.inactive' | translate }}
                </ng-container>
                <ng-container *ngIf="flashingOptionIsOpen">
                    {{ 'mimic.settings.button-intercation.active' | translate }}
                </ng-container>
            </div>
            <mat-slide-toggle
                class="toggle"
                [checked]="flashingOptionIsOpen"
                (change)="updateToggle($event)"
                [disabled]="isDisabled">
            </mat-slide-toggle>
        </div>
    </div>

    <ng-container *ngIf="flashingOptionIsOpen">
        <div *ngIf="!flashingChannel" class="select-button">
            <div style="cursor: pointer" (click)="openChannelSelector()">
                {{ 'mimic.settings.system-integration.button.select' | translate }}
            </div>
            <div class="error-message">
                {{ 'mimic.settings.system-integration.button.select.error' | translate }}
            </div>
        </div>
        <ng-container *ngIf="flashingChannel && !isLoadingChannel">
            <app-system-integration-channel
                [assignedChannel]="flashingChannel"
                (onRemoveChannel)="removeAssignedChannel()"
                [removePadding]="true"
                (onOpenSelector)="openChannelSelector()">
            </app-system-integration-channel>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="flashingChannel && flashingOptionIsOpen">
        <div class="flashing-color-container">
            <div
                class="color-picker-container"
                #colorPickerDiv
                [style.--picker-top]="pickerTop + 'px'"
                [style.--picker-left]="pickerLeft + 'px'">
                <input
                    readonly
                    class="color-input"
                    (cpToggleChange)="onPickerStateChange($event)"
                    [(colorPicker)]="flashingColor"
                    cpPosition="bottom-left"
                    [style.background]="flashingColor" />
            </div>

            <div class="color-container">
                <div>
                    {{ 'mimics.settings.button.flashing.color' | translate }}
                </div>
                <div class="color-input">{{ flashingColor }}</div>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="flashingChannel && flashingOptionIsOpen">
        <div class="fieldset-container">
            <fieldset class="fieldset" [class.selected]="startStatusOpen">
                <legend class="legend" [class.selected]="startStatusOpen">
                    {{ 'mimics.settings.button.flashing.start.legend' | translate }}
                </legend>
                <mat-select
                    class="input"
                    panelClass="flashing-status-panel"
                    [(ngModel)]="startStatus"
                    (openedChange)="startStatusOpen = !startStatusOpen"
                    (ngModelChange)="onStartStatusChange($event)">
                    <ng-container *ngFor="let status of statusOptions">
                        <mat-option [value]="status" class="flashing-status-option">
                            {{ status }}
                        </mat-option>
                    </ng-container>
                </mat-select>
            </fieldset>
            <div *ngIf="!startStatus" class="fieldset-error">
                {{ 'mimic.settings.system-integration.button.status.error' | translate }}
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="flashingChannel && flashingOptionIsOpen">
        <div class="fieldset-container">
            <fieldset class="fieldset" [class.selected]="terminateStatusOpen">
                <legend class="legend" [class.selected]="terminateStatusOpen">
                    {{ 'mimics.settings.button.flashing.terminate.legend' | translate }}
                </legend>
                <mat-select
                    class="input"
                    panelClass="flashing-status-panel"
                    [(ngModel)]="terminateStatus"
                    (openedChange)="terminateStatusOpen = !terminateStatusOpen"
                    (ngModelChange)="onTerminateStatusChange($event)">
                    <ng-container *ngFor="let status of statusOptions">
                        <mat-option [value]="status" class="flashing-status-option">
                            {{ status }}
                        </mat-option>
                    </ng-container>
                </mat-select>
            </fieldset>
            <div *ngIf="!terminateStatus" class="fieldset-error">
                {{ 'mimic.settings.system-integration.button.status.error' | translate }}
            </div>
        </div>
    </ng-container>
</div>
